import React, {useState} from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import uniqid from 'uniqid'
import DeleteButton from '../atoms/buttons/DeleteButton'

const PublicationImages = ({editMode, images}) => {
  const [openLightbox, setOpenLightbox] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)

  return (
    <>
      <section className={`publication-images ${editMode && 'edit-mode'}`}>
        {images.map((image, index) => (
          <div className="image-container" key={uniqid()}>
            <img
              onClick={() => {
                setPhotoIndex(index)
                setOpenLightbox(true)
              }}
              className="image"
              src={image}
              alt="Imagen de publicación"
            />
            {editMode && <DeleteButton title="Borrar imagen" />}
          </div>
        ))}
      </section>
      {openLightbox && !editMode && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setOpenLightbox(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
        />
      )}
    </>
  )
}

export default PublicationImages
